
import RowSection from "../components/industries/RowSection.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    RowSection
  },
  data() {
    return {
      isLoading: false,
      step2Form: {
        firstName: "",
        middleName: "",
        lastName: "",
        businessName: "",
        email: "",
        phone: "",
        content: "",
        streetAddress: "",
        streetAddress2: "",
        cityName: "",
        title: "",
        city: "",
        personDocumentType: "",
        zipCode: "",
        state: "",
        ssn: "",
        dateOfBirth: "",
        dateOfBirth2: "",
        homeOwnership: "",
        military: false,
        month: "",
        housingCost: ""
      },
      rules: {
        firstName: [
          { required: true, message: 'First Name is required', trigger: 'blur' }
        ],
        lastName: [
          { required: true, message: 'Last Name is required', trigger: 'blur' }
        ],
        email: [
          { required: true, message: 'Email is required', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: 'Phone is required', trigger: 'blur' }
        ]
      }
    };
  },
  computed: {
    // ...mapGetters({
    //   userInfo: types.GET_USER
    // })
  },
  methods: {
    // submitForm() {
    //   this.$refs['step2Form'].validate((valid) => {
    //     if (valid) {
    //       this.isLoading = true;
    //       var _this = this;
    //       api
    //         .postForm("/common/sysfeedback/mgxyPartner.ht", {
    //           tokenId: _this.userInfo.token,
    //           firstName: _this.step2Form.firstName,
    //           lastName: _this.step2Form.lastName,
    //           email: _this.step2Form.email,
    //           phone: _this.step2Form.phone,
    //           content: "Partnership message: " + _this.step2Form.content
    //         })
    //         .then(res => {
    //           this.$router.push({
    //             path: `/`,
    //             query: {}
    //           });
    //         });
    //     } else {
    //       console.log('error submit!!');
    //     }
    //   });
    // }
  },
  mounted() {
  },
  head() {
    return {
      title: 'Boost Your Sales with American Credit\'s Vendor Financing Program',
      meta : [
        {
          hid: 'description',
          name: 'description',
          content: 'Boost your sales with American Credit\'s Vendor Financing Program, offering fully-digital, flexible equipment financing options for your clients.'
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'american credit partners, Experian, Plaid, Ocrolus, Salesforce, IBM, SBA, American Credit, amcredit'
        }
      ]
    }
  }
};
